const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

export const regionName = (code: string): string => {
  try {
    return regionNames.of(code) ?? code;
  } catch {
    return code;
  }
};
